import React from 'react';
import HeroSection from '../../components/home/HeroSection';
import QuoteForm from '../../components/home/QuoteForm';
import ServiceTrusted from '../../components/service/ServiceTrusted';
import trustedImg from '../../assets/img/servicetrusted/8.png';
import ServicesSection from '../../components/home/ServicesSection';
import DiscussionSection from '../../components/home/DiscussionSection';
import CadDraftingProcess from '../../components/service/CadDraftingProcess';
import CadDraftingIndustries from '../../components/service/CadDraftingIndustries';
import ProjectsSection from '../../components/home/ProjectsSection';
import TestimonialsSection from '../../components/home/TestimonialsSection';
import IndustriesSection from '../../components/home/IndustriesSection';
import SoftwaresSection from '../../components/home/SoftwaresSection';
import AwardsSection from '../../components/home/AwardsSection';
import FAQSection from '../../components/home/FAQSection';
import BlogsSection from '../../components/home/BlogsSection';
import ContactSection from '../../components/home/ContactSection';


import experiencedImg from '../../assets/img/indus/Experienced team.png';
import techEdgeImg from '../../assets/img/indus/Technological Advantage.png';
import communicationImg from '../../assets/img/indus/Effective Communication.png';
import fasterMarketImg from '../../assets/img/indus/Faster Time to Market.png';
import qualityStandardsImg from '../../assets/img/indus/High-Quality Standards.png';
import bestValueImg from '../../assets/img/indus/Best Value.png';

const CadDraftingPage = () => {
  const cadDraftingValues = [
    {
      title: "Experienced CAD Professionals",
      desc: "Our team consists of skilled drafters with years of experience in residential, commercial, and mechanical CAD drafting. Every project is handled with precision and attention to detail.",
      icon: (
        <div className="anim-float">
          <img src={experiencedImg.src || experiencedImg} alt="Team" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
      )
    },
    {
      title: "Fast Turnaround Time",
      desc: "We understand deadlines are crucial. Our efficient workflow ensures your 2D and 3D CAD drawings are delivered on time, every time.",
      icon: (
        <div className="cog-spin">
          <img src={fasterMarketImg.src || fasterMarketImg} alt="Speed" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
      )
    },
    {
      title: "High-Quality & Accurate Deliverables",
      desc: "We guarantee error-free, industry-standard CAD files compatible with AutoCAD, Revit, SolidWorks, and other major platforms.",
      icon: (
        <div className="award-shine">
          <img src={qualityStandardsImg.src || qualityStandardsImg} alt="Quality" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
      )
    },
    {
      title: "Editable & Flexible CAD Files",
      desc: "All our CAD models are fully editable, allowing you to make future revisions or adjustments with ease.",
      icon: (
        <div className="anim-float">
          <img src={techEdgeImg.src || techEdgeImg} alt="Flexible" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
      )
    },
    {
      title: "Affordable & Transparent Pricing",
      desc: "No hidden costs! Our pricing is competitive and customized to project complexity, making it ideal for businesses and individuals alike.",
      icon: (
        <div className="dollar-float">
          <img src={bestValueImg.src || bestValueImg} alt="Pricing" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
      )
    },
    {
      title: "Seamless Communication",
      desc: "We maintain clear and consistent communication throughout the project, ensuring your requirements are fully understood and implemented.",
      icon: (
        <div className="chat-bounce">
          <img src={communicationImg.src || communicationImg} alt="Communication" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
      )
    }
  ];

  return (
    <div className="cad-drafting-page">
      <HeroSection
        overline="CAD Drafting Services in USA"
        staticTitle={
          <>
            Expert 2D & 3D Drafting Solutions
            <span className="text-primary"> for </span><br />
          </>
        }
        typingWords={["Residential", "Commercial", "& Industrial Projects"]}
        typingColor="var(--color-primary)"
        description="We offer high-quality and accurate CAD design and CAD Drafting services for your construction endeavors. Our expert CAD Drafter teams possess years of experience in catering construction design consultancy, MEP consultancy, landscaping, interior map designing, and more drafting services. We deliver conceptual drawing blueprints that ensure detail, precision, and productivity in managing construction projects for our contractors."
        buttonText="Request Quote"
      />

      <QuoteForm customStyle={{ marginTop: '-65px' }} />

      <ServiceTrusted
        title={<><span className="text-primary">Professional CAD</span> Drafting <br /> Services You Can Trust</>}
        paragraphs={[
          "At Chudasama Outsourcing, we provide top-quality CAD Drafting Services in the USA tailored to your project needs. From residential floor plans to complex industrial designs, our team delivers precise, efficient, and cost-effective CAD solutions. Whether you need 2D technical drawings or 3D modeling, we ensure your vision comes to life with accuracy and speed.",
          "We understand the importance of US-standard compliance, fast turnarounds, and clear communication, making us the trusted choice for architects, engineers, and project managers across the country."
        ]}
        imgSrc={trustedImg}
      />
      <ServicesSection />
      <DiscussionSection
        title={<><span className="text-primary">Get Your Custom CAD</span> Drafting Quote Today</>}
        subtitle="Don’t compromise on accuracy or quality. Whether it’s 2D drafting, 3D modeling, or mechanical designs, our experts are ready to bring your ideas to life."
        buttonText="Book a Free Consultation"
      />
      <CadDraftingProcess />
      <CadDraftingIndustries />
      <ProjectsSection />
      <TestimonialsSection />
      <DiscussionSection
        title={<><span className="text-primary">Ready for a quote</span> on your BIM project?</>}
        subtitle="Contact our sales team today for a free quote on your industry-related architecture BIM project."
        buttonText="Connect With a Teach Expert"
      />
      <IndustriesSection
        title={<><span className="text-primary">Why Choose Our</span> CAD Drafting Services</>}
        subtitle="When it comes to CAD Drafting Services in the USA, accuracy, speed, and reliability matter most. Here’s why businesses and professionals trust us:"
        coreValues={cadDraftingValues}
      />
      <SoftwaresSection />
      <AwardsSection />
      <FAQSection
        title={<><span className="text-primary">FAQs</span> – CAD Drafting Services</>}
        faqs={[
          {
            question: "What Is Included In CAD Drafting Services?",
            answer: "Our CAD drafting services include 2D technical drawings, 3D CAD modeling, floor plans, elevations, sections, site plans, and detailed construction documentation tailored for architects, engineers, and contractors."
          },
          {
            question: "How Fast Can You Deliver CAD Drawings?",
            answer: "Turnaround times vary based on project scale and complexity, but we typically deliver initial drafts within 2-5 business days. We also offer expedited services for urgent project deadlines."
          },
          {
            question: "Do You Provide Revisions?",
            answer: "Yes, we provide revisions to ensure the final technical drawings perfectly align with your project requirements and specified technical standards."
          },
          {
            question: "Are Your Services USA-Compliant?",
            answer: "Absolutely. We follow all major international standards, including AIA (American Institute of Architects), and ensure strict compliance with local US building codes and drafting requirements."
          }
        ]}
      />
      <BlogsSection />
      <ContactSection />
    </div>
  );
};

export default CadDraftingPage;
